module.exports = __webpack_public_path__ + "static/media/StopWatch.15e77801.WebP";